export default reducers => (state, action) =>
  Object.keys(reducers).reduce((acc, reducerKey) => {
    const reducer = reducers[reducerKey];

    if (reducer) {
      const newState = reducer({ ...state[reducerKey] }, action);
      return { ...acc, [reducerKey]: { ...newState } };
    }

    return { ...acc };
  }, state);
